(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vstd-lp-074a-erae"] && !Shopify.designMode) return;
  try {
    
(function(){
  function init(){
    var bar = document.querySelector('.el-723782');
    if(!bar) return;
    function tick(){
      var doc = document.documentElement;
      var scrolled = window.scrollY || doc.scrollTop;
      var total = (doc.scrollHeight - window.innerHeight) || 1;
      if(scrolled/total >= 0.4) bar.classList.add('bwg-show');
      else bar.classList.remove('bwg-show');
    }
    window.addEventListener('scroll', tick, {passive:true});
    window.addEventListener('resize', tick);
    tick();
  }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();

  } catch(e) { console.error(e); }
})();
})();
